import i18n from 'i18next';
import axios from 'axios';

const MODE = process.env.REACT_APP_MODE || 'PRODUCTION';

// LOCAL defaults: API proxied via :8082 → Tomcat :8080, SM on :8081.
// Copy gsc-react-frontend/.env.development.local.example → .env.development.local
const CONFIGS = {
  LOCAL: {
    GOOGLE_API_KEY: 'AIzaSyAIXvgxiybI4Ru8O54_qqCxpeVWhRuKPD0',
    GOOGLE_CLIENT_ID: '643378504561-o207o7hsp1me1n3rru6mp9367k8agmdc.apps.googleusercontent.com',
    API_ROOT: process.env.REACT_APP_API_ROOT || 'http://localhost:8080',
    SM_URL: process.env.REACT_APP_SM_URL || 'http://localhost:8081',
    APP_ID: '643378504561',
    APP_URL: process.env.REACT_APP_APP_URL || 'http://localhost:8082',
    CHROME_EXT_ID: 'nhmihkokjnmeaagjihlamgohjfmapehj',
    BRANCH_IO_ENV: 'test',
    BRANCH_IO_KEY: 'key_test_hDDcfDjiuJtWRjihSADk4pohttbrSFLt'
  },
  STAGING: {
    GOOGLE_API_KEY: 'AIzaSyAIXvgxiybI4Ru8O54_qqCxpeVWhRuKPD0',
    GOOGLE_CLIENT_ID: '643378504561-o207o7hsp1me1n3rru6mp9367k8agmdc.apps.googleusercontent.com',
    API_ROOT: process.env.REACT_APP_API_ROOT || 'https://staging-app.contactsflow.ai',
    SM_URL: process.env.REACT_APP_SM_URL || 'https://staging-billing.contactsflow.ai',
    APP_ID: '643378504561',
    APP_URL: process.env.REACT_APP_APP_URL || 'https://staging-app.contactsflow.ai',
    CHROME_EXT_ID: 'nhmihkokjnmeaagjihlamgohjfmapehj',
    BRANCH_IO_ENV: 'test',
    BRANCH_IO_KEY: 'key_test_hDDcfDjiuJtWRjihSADk4pohttbrSFLt'
  },
  PRODUCTION: {
    GOOGLE_API_KEY: 'AIzaSyAIXvgxiybI4Ru8O54_qqCxpeVWhRuKPD0',
    GOOGLE_CLIENT_ID: '1033860418004-dedj58ulns49sr6sjb8d0jko2qkvlu8b.apps.googleusercontent.com',
    API_ROOT: 'https://app.contactsflow.ai',
    SM_URL: 'https://billing.contactsflow.ai',
    APP_ID: '1033860418004',
    APP_URL: 'https://app.contactsflow.ai',
    CHROME_EXT_ID: 'mpdjmbhegfblkgnkhdfiepfljmhekaag',
    BRANCH_IO_ENV: 'live',
    BRANCH_IO_KEY: 'key_live_frzakFlcqSr9ScjbGsFm5fmkDqpxMzVK'
  }
};

const activeConfig = CONFIGS[MODE] || CONFIGS.PRODUCTION;

const isLocalHost = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1';

/** Phase A split-stack: React HMR on :8082, API on :8080, SM on :8081. */
const isLocalSplitStackDev = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const { hostname, port } = window.location;
  return isLocalHost(hostname) && port === '8082';
};

const useOrigin =
  typeof window !== 'undefined' &&
  window.location &&
  !isLocalHost(window.location.hostname);

const resolveEndpoints = () => {
  if (isLocalSplitStackDev()) {
    // Same origin as CRA (:8082); setupProxy.js forwards to Tomcat (:8080).
    return {
      API_ROOT: window.location.origin,
      APP_URL: window.location.origin,
      SM_URL: 'http://localhost:8081',
    };
  }
  if (useOrigin) {
    const origin = window.location.origin;
    const smUrl = process.env.REACT_APP_SM_URL || activeConfig.SM_URL;
    const resolvedSm =
      smUrl && smUrl.includes('localhost')
        ? window.location.hostname.includes('staging')
          ? 'https://staging-billing.contactsflow.ai'
          : 'https://billing.contactsflow.ai'
        : smUrl;
    return { API_ROOT: origin, APP_URL: origin, SM_URL: resolvedSm };
  }
  return {
    API_ROOT: activeConfig.API_ROOT,
    APP_URL: activeConfig.APP_URL,
    SM_URL: activeConfig.SM_URL,
  };
};

const endpoints = resolveEndpoints();

// Safety check: resolve SM_URL dynamically if running on a remote origin
const getResolvedSmUrl = () => endpoints.SM_URL;

export const GOOGLE_API_KEY = activeConfig.GOOGLE_API_KEY;
export const GOOGLE_CLIENT_ID = activeConfig.GOOGLE_CLIENT_ID;
export const API_ROOT = endpoints.API_ROOT;
export const SM_URL = getResolvedSmUrl();
export const APP_ID = activeConfig.APP_ID;
export const APP_URL = endpoints.APP_URL;
export const CHROME_EXT_ID = activeConfig.CHROME_EXT_ID;
export const BRANCH_IO_ENV = activeConfig.BRANCH_IO_ENV;
export const BRANCH_IO_KEY = activeConfig.BRANCH_IO_KEY;

/**
 * Absolute return URL for backend OAuth/login so the browser comes back to the
 * React dev UI origin (:8082) instead of Tomcat (:8080).
 */
export const authReturnUrl = (pathWithSearch) => {
	const path =
		pathWithSearch != null
			? pathWithSearch
			: typeof window !== 'undefined'
				? window.location.pathname + window.location.search
				: '/';
	if (/^https?:\/\//i.test(path)) {
		return path;
	}
	const base = (APP_URL || '').replace(/\/$/, '');
	const suffix = path.startsWith('/') ? path : `/${path}`;
	return `${base}${suffix}`;
};

export const API_GET_SALESIQ_TOKEN_URL = API_ROOT + '/api/salesiq/token';
export const API_GET_CONTACT_GROUPS_URL = API_ROOT + '/api/labels';
export const API_POST_CONTACT_GROUPS_URL = API_ROOT + '/api/labels/share';
export const API_GET_GROUP_COLLABORATORS_URL =
  API_ROOT + '/api/labels';
export const API_GET_DOMAIN_GROUP_URL = API_ROOT + '/v9/api/domain-group';
export const API_GET_LOGS_URL = API_ROOT + '/api/event/logs';



export const googleSignIn = () => {
	if (window.gapi) {
		window.gapi.load('auth2', () => {
			window.gapi.auth2.init({
				client_id: GOOGLE_CLIENT_ID,
				scope: 'https://www.googleapis.com/auth/admin.directory.user.readonly',
			});
		});
	}
};


export const translate = (key, config) => i18n.t(key, config);
export const sharedWordRemove = (string) => {
	if (string.match(/( \(shared\))$/i)) {
		return string.substr(0, string.length - 9);
	} else {
		return string;
	}
};

export const permissionCleaner = (permission) => {
	switch (permission) {
		case 'OWNER':
			return translate('popupSharingOwner');
		case 'CAN_SHARE':
			return translate('popupSharingReshareText');
		case 'WRITE_DELETE':
			return translate('popupSharingDeleteText');
		case 'WRITE_ONLY':
			return translate('popupSharingEditText');
		case 'READ_ONLY':
			return translate('popupSharingViewOnlyInfo');
		default:
			break;
	}
};

export const collaboratorStatusCleaner = (status) => {
	switch (status) {
		case 'normal':
			return 'Normal';
		case 'invitationPending':
			return translate('userStatusInvitationPending');
		case 'invitationWarning':
			return translate('userStatusInvitationSent');
		case 'suspended':
			return translate('userStatusGoogleAccounSuspended');
		case 'licenseLimitReached':
			return translate('userStatusLicenseLimitReached');
		case 'partiallyShared':
			return translate('partiallySharedText');
		case 'revoked':
			return translate('userStatusPermissionLost');
		case 'overQuota':
			return translate('userStatusGoogleLimitReached');
		case 'sharingLimitReached':
			return translate('userStatusSharingLimitReached');
		case 'deleted':
			return translate('userStatusGoogleAccountDeleted');
		case 'banned':
			return translate('userStatusGoogleAccounBanned');
		case 'upgradeNow':
			return translate('userStatusUpgradeRequired');
		case 'unknown':
			return translate('unknownCollaboratorText');
		default:
			return null;
	}
};

export const contactsGroupStatusCleaner = (status) => {
	switch (status) {
		case 'SHARED':
			return translate('textShared');

		case 'NOT_SHARED':
			return (
				translate('textNotShared')
			);
		case 'SHARED_WITH_ME':
			return (
				translate('textSharedWithMe')
			);
		default:
			return null;
	}
};

export const deepCopy = (block) => {
	let out = null;

	if (Array.isArray(block)) {
		out = [];
		for (let index = 0; index < block.length; ++index) {
			let subArray = block[index];
			out.push(typeof subArray === 'object' ? deepCopy(subArray) : subArray);
		}
	} else {
		out = {};
		for (let key in block) {
			let subObject = block[key];
			out[key] =
				typeof subObject === 'object' ? deepCopy(subObject) : subObject;
		}
	}
	return out;
};

export const checkEmailFormat = (string) => {
	let re = new RegExp(/^([\w\-.]+)@([\w\-.]+)\.([\w]+)$/);
	return re.test(string);
};

export const upperCaseFirstLetter = (string) => {
	return string.charAt(0).toLocaleUpperCase() + string.substr(1);
};

export const isEmptyObj = (obj) => {
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) return false;
	}
	return true;
};

export const loadZohoSalesIQ = () => {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.innerHTML =
		'var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode:"c8e502b5c5122a57cb5f5374937ea4c8d3a438c197c537e6a4178eb36a9348e3cb81400b4adfa0a062b2ce6354f7385b", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);d.write=function(node){document.body.insertAdjacentHTML(\'beforeend\', node)}';
	document.head.appendChild(script);
};

/**
 * Attaches the backend-signed identity token (JWT) to the SalesIQ widget as
 * visitor custom info. The chatbot gateway verifies this token to know who the
 * visitor really is — visitor.name()/email() are display-only and spoofable.
 *
 * Fail-safe by design: while the GSC endpoint is not deployed (404) or the
 * session is expired (401), this silently does nothing and the widget keeps
 * working exactly as before.
 */
let lastGscIdentityAttemptMs = 0;

export const attachGscIdentity = () => {
	lastGscIdentityAttemptMs = Date.now();
	axios.get(API_GET_SALESIQ_TOKEN_URL, {withCredentials: true})
		.then((response) => {
			const token = response.data && response.data.token;
			if (token && window.$zoho && window.$zoho.salesiq
				&& window.$zoho.salesiq.visitor && window.$zoho.salesiq.visitor.info) {
				window.$zoho.salesiq.visitor.info({gsc_jwt: token});
			}
		})
		.catch(() => {
			// Extra metadata only — never block or degrade the chat.
		});
};

/**
 * Refreshes the identity token only if the last attempt is older than maxAgeMs.
 * Used by periodic/visibility refreshes so a user flipping between tabs does not
 * hammer the endpoint, while chat opens still call attachGscIdentity() directly
 * for a guaranteed-fresh token.
 */
export const refreshGscIdentityIfStale = (maxAgeMs) => {
	if (Date.now() - lastGscIdentityAttemptMs >= maxAgeMs) {
		attachGscIdentity();
	}
};

export const facebookPixel = () => {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.innerHTML =
		'!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');fbq(\'init\', \'287479325710326\'); fbq(\'track\', \'PageView\');';
	document.head.appendChild(script);

	const noScript = document.createElement('noscript');
	const img = document.createElement('img');
	img.height = '1';
	img.width = '1';
	img.src =
		'https://www.facebook.com/tr?id=287479325710326&ev=PageView&noscript=1';
	noScript.appendChild(img);
	document.head.appendChild(noScript);
};

export const linkedInPixel = () => {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.innerHTML =
		'_linkedin_partner_id = "1090996"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id);(function(){var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})();';
	document.head.appendChild(script);

	const noScript = document.createElement('noscript');
	const img = document.createElement('img');
	img.height = '1';
	img.width = '1';
	img.src = 'https://dc.ads.linkedin.com/collect/?pid=1090996&fmt=gif';
	noScript.appendChild(img);
	document.head.appendChild(noScript);
};

export const quoraPixel = () => {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.innerHTML =
		'!function(q,e,v,n,t,s){if(q.qp) return; n=q.qp=function(){n.qp?n.qp.apply(n,arguments):n.queue.push(arguments);}; n.queue=[];t=document.createElement(e);t.async=!0;t.src=v; s=document.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);}(window, \'script\', \'https://a.quora.com/qevents.js\');qp(\'init\', \'ac96eae1871d4aa292fc08949b95b1bb\');qp(\'track\', \'ViewContent\');';
	document.head.appendChild(script);

	const noScript = document.createElement('noscript');
	const img = document.createElement('img');
	img.height = '1';
	img.width = '1';
	img.style.display = 'none';
	img.src =
		'https://q.quora.com/_/ad/ac96eae1871d4aa292fc08949b95b1bb/pixel?tag=ViewContent&noscript=1';
	noScript.appendChild(img);
	document.head.appendChild(noScript);
};

export const calendlyWidget = () => {

	const link = document.createElement('link');
	link.href = 'https://assets.calendly.com/assets/external/widget.css';
	link.rel = 'stylesheet';

	const wScript = document.createElement('script');
	wScript.src = 'https://assets.calendly.com/assets/external/widget.js';
	wScript.type = 'text/javascript';
	wScript.async = true;

	/*
	const cScript = document.createElement('script');
	cScript.type = 'text/javascript';
	cScript.innerHTML = 'window.onload = function() { Calendly.initBadgeWidget({ url: \'https://calendly.com/sidgar\', text: \'Book a Live Demo\', color: \'#00a2ff\', textColor: \'#ffffff\', branding: true }); }'
	*/

	document.head.appendChild(link);
	document.head.appendChild(wScript);
	//document.head.appendChild(cScript);

};

export const getDate = (timestamp) => {
	let myDate = new Date(timestamp);
	return myDate.toISOString();
};

export const urlParam = (name) => {
	let results = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i').exec(
		window.location.href
	);
	if (!results) {
		return '';
	}
	return window.decodeURI(results[1].replace(/\+/g, ' ')) || '';
};

export const dropDownPosition = (container, field, dropDown, leftMargin) => {
	let currentFieldPos = field;
	let currentDropDownPos = dropDown;
	let fieldRect = field.getBoundingClientRect();
	let shift = 0;

	if (currentDropDownPos) {
		currentDropDownPos.style.right =
			document.body.getBoundingClientRect().width -
			fieldRect.x -
			fieldRect.width +
			'px';
		currentDropDownPos.style.top = fieldRect.y + fieldRect.height - 1 + 'px';
		currentDropDownPos.style.minWidth = fieldRect.width + 'px';

		/*if(
			dropDown.getBoundingClientRect().right + dropDown.getBoundingClientRect().width < document.body.clientWidth
			|| leftMargin
		){
			currentDropDownPos.style.left = fieldRect.x + 'px';
		}*/

		if(leftMargin){
			currentDropDownPos.style.left = fieldRect.x + 'px';
		}

		if (
			currentDropDownPos.getBoundingClientRect().y +
			currentDropDownPos.getBoundingClientRect().height >
			document.body.getBoundingClientRect().height
		) {
			shift =
				currentDropDownPos.getBoundingClientRect().height +
				currentFieldPos.getBoundingClientRect().height -
				2;
			currentDropDownPos.style.top =
				fieldRect.y + fieldRect.height - 1 - shift + 'px';
		}
	}

	window.onresize = () => {
		dropDownPosition(container, currentFieldPos, currentDropDownPos, leftMargin);
	};

	container.onscroll = () => {
		dropDownPosition(container, currentFieldPos, currentDropDownPos, leftMargin);
	};
};

export const setDragInfoPos = (x, y) => {
	if (document.querySelector('.drag-info')) {
		document.querySelector('.drag-info').style.transform =
			'translateX(' + x + 'px) translateY(' + y + 'px)';
		document.querySelector('.drag-info').style.display = 'block';
	}
};

export const waitTill = () => new Promise((res) => setTimeout(res, 300));

export const textTruncation = (str, num) => {
	if (str.length > num) {
		return str.slice(str, num) + '…';
	} else {
		return str;
	}
};

export const parseLink = ( string ) => {
	//const regex = /https?:\/\/[^\s/$.?#].[^\s]*/gi;
	const regex = /(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?/gi;

	const parts = [];
	let lastIndex = 0;

	let match;
	while ((match = regex.exec(string)) !== null) {
		const url = match[0];
		const start = match.index;

		// texte avant le lien
		if (start > lastIndex) {
			parts.push(string.slice(lastIndex, start));
		}

		// lien transformé en <a>
		parts.push(
			<a href={url} target="_blank" rel="noopener noreferrer" key={start}>
				{url}
			</a>
		);

		lastIndex = regex.lastIndex;
	}

	// texte après le dernier lien
	if (lastIndex < string.length) {
		parts.push(string.slice(lastIndex));
	}

	return parts;
};

export function urlStringToOperator(operator) {
	const operatorMap = {
		'IS': encodeURIComponent('='),
		'IS_EMPTY': encodeURIComponent('=null'),
		'IS_NOT_EMPTY': encodeURIComponent('!=null'),
		'CONTAINS': encodeURIComponent('~'),
		'NOT_CONTAINS': encodeURIComponent('!~'),
		'GREATER_THAN': encodeURIComponent('>'),
		'LOWER_THAN': encodeURIComponent('<'),
		'IS_BEFORE': encodeURIComponent('<<'),
		'IS_AFTER': encodeURIComponent('>>')
	};

	return operatorMap[operator] || '';
}

export function urlOperatorToString(operator) {
	const operatorMap = {
		[encodeURIComponent('=')]: 'IS',
		[encodeURIComponent('=null')]: 'IS_EMPTY',
		[encodeURIComponent('!=null')]: 'IS_NOT_EMPTY',
		[encodeURIComponent('~')]: 'CONTAINS',
		[encodeURIComponent('!~')]: 'NOT_CONTAINS',
		[encodeURIComponent('>')]: 'GREATER_THAN',
		[encodeURIComponent('<')]: 'LOWER_THAN',
		[encodeURIComponent('<<')]: 'IS_BEFORE',
		[encodeURIComponent('>>')]: 'IS_AFTER'
	};

	return operatorMap[operator] || '';
}

export const toUtcMidnightISOString = (dateObj) => {
	return new Date(
		Date.UTC(
			dateObj.getFullYear(),
			dateObj.getMonth(),
			dateObj.getDate()
		)
	).toISOString();
};

export const toLocalISOString = (dateObj) => {
	return dateObj.toISOString();
};

export const normalizeCriteriaValue = (field, rawValue) => {
	if (!rawValue) return { value: "", error: null };

	if(["birthday", "createdDate", "modifiedTime"].includes(field)) {
		const dateObj = new Date(rawValue);

		if (isNaN(dateObj.getTime())) {
			return { value: "", error: "Invalid date" };
		}

		if (field === "birthday") {
			return { value: toUtcMidnightISOString(dateObj), error: null };
		}

		return { value: toLocalISOString(dateObj), error: null };
	}

	if (field === "phoneNumber") {
		if (!isValidPhone(rawValue)) {
			return { value: rawValue, error: "Invalid phone number" };
		}
		return { value: rawValue, error: null };
	}

	if (field === "email") {
		if (!isValidEmail(rawValue)) {
			return { value: rawValue, error: "Invalid email address" };
		}
		return { value: rawValue, error: null };
	}

	return { value: rawValue, error: null };
};

export const formatDateForInput = (val) => {
	if (!val) return "";
	const dateObj = new Date(val);
	if (isNaN(dateObj.getTime())) return "";
	return dateObj.toISOString().split("T")[0];
};

export const toLocalDateTime = (date) => {
	const dateObj = new Date(date);
	return dateObj.toLocaleString();
};

export const toLocalDateTimeWithoutSeconds = (date) => {
	const dateObj = new Date(date);
	return dateObj.toLocaleString([], {day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute:'numeric'});
};

const isValidPhone = (val) => {
	const regex = /^(\+?[0-9]{1,3})?[-. ]?([0-9]{2,4}[-. ]?){2,5}[0-9]{2,4}$/;
	return regex.test(val);
};

const isValidEmail = (val) => {
	const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return regex.test(val);
};

/*export function toLocalISOString(date) {
	const pad = n => String(n).padStart(2, '0');
	const year = date.getFullYear();
	const month = pad(date.getMonth() + 1);
	const day = pad(date.getDate());
	const hours = pad(date.getHours());
	const minutes = pad(date.getMinutes());
	const seconds = pad(date.getSeconds());

	const tzOffset = -date.getTimezoneOffset();
	const sign = tzOffset >= 0 ? "+" : "-";
	const absOffset = Math.abs(tzOffset);
	const offsetHours = pad(Math.floor(absOffset / 60));
	const offsetMinutes = pad(absOffset % 60);

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
}*/

export const generateId = () => Date.now().toString() + Math.random().toString(36).substring(2, 7);

export const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};
